export const REJECTED = '605cbaafd5fc4809e161c526';
export const VISIT_REJECTED = '60ae5d5f60638f03e9c629ce';
export const VISIT = '6064f8065b21e51052eed547';
export const VISIT_FOLLOWING = '60ae5f1160638f03e9c629cf';
export const SALE_STATUS_ID = '5d7a514b5dac12c7449ce043';

export const LEAD = '605bd4e80a4330245535db3c';
export const LEAD_FOLLOWING = '605bd5e1bed49524ae40f883';
export const SUBSTATUS_NEW = '605bd5c4bed49524ae40f882';
export const STATUS_APPOINTMENT = '604f80222b372e0cb11966dc';
export const STATUS_VISIT = '6064f8065b21e51052eed547';
export const STATUS_SALE = '5d7a514b5dac12c7449ce043';
export const SUBSTATUS_DUPLICATED = '644ac1417fb19d012057f83e';

export const SUBSTATUSES_REJECTED = [REJECTED, VISIT_REJECTED];

export const SUBSTATUS_RESCHEDULED_APPOINTMENT = '605bd717bed49524ae40f888';

export const STATUSES = {
    DEFAULT: {
        ID: '5d7a514b5dac12c7449ce044',
        NAME: 'Default',
        LEVEL: 0,
    },
    LEAD: {
        ID: '605bd4e80a4330245535db3c',
        NAME: 'Lead',
        LEVEL: 1,
        SUBSTATUSES: {
            NEW: {
                ID: '605bd5c4bed49524ae40f882',
                NAME: 'New',
            },
            WRONG_NUMBER: {
                ID: '605cbaa6d5fc4809e161c525',
                NAME: 'Wrong Number',
            },
            RSI: {
                ID: '60f5f121220e7770fea7b7d4',
                NAME: 'RSI',
            },
            FOLLOW_UP: {
                ID: '605bd5e1bed49524ae40f883',
                NAME: 'Follow Up',
            },
            CALL_AGAIN: {
                ID: '605bd5eebed49524ae40f884',
                NAME: 'Call Again',
            },
            DOCUMENTATION: {
                ID: '605ce990c053b6162cf1c2ac',
                NAME: 'Documentation',
            },
            DUPLICATED: {
                ID: '644ac1417fb19d012057f83e',
                NAME: 'Duplicated',
            },
            REJECTED: {
                ID: '605cbaafd5fc4809e161c526',
                NAME: 'Rejected',
            },
        },
    },
    APPOINTMENT: {
        ID: '604f80222b372e0cb11966dc',
        NAME: 'Appointment',
        LEVEL: 2,
        SUBSTATUSES: {
            VISIT_TRACKING: {
                ID: '605bd6c4bed49524ae40f886',
                NAME: 'Visit Tracking',
            },
            CONFIRM: {
                ID: '605bd6b0bed49524ae40f885',
                NAME: 'Confirm',
            },
            CLIENT_NA: {
                ID: '605bd729bed49524ae40f889',
                NAME: 'Client NA',
            },
            RESCHEDULE: {
                ID: '605bd717bed49524ae40f888',
                NAME: 'Reschedule',
            },
            CONFIRMED: {
                ID: '605bce8ba04514212f1fac67',
                NAME: 'Confirmed',
            },
        },
    },
    VISIT: {
        ID: '6064f8065b21e51052eed547',
        NAME: 'Visit',
        LEVEL: 3,
        SUBSTATUSES: {
            VISIT_REJECTED: {
                ID: '60ae5d5f60638f03e9c629ce',
                NAME: 'Visit Rejected',
            },
            CONDITIONED_APPLICATION: {
                ID: '606e233bc00bcb15b5e70824',
                NAME: 'Conditioned Application',
            },
            VISIT_FOLLOWUP: {
                ID: '60ae5f1160638f03e9c629cf',
                NAME: 'Visit Followup',
            },
            APPLICATION: {
                ID: '606e22fcc00bcb15b5e70822',
                NAME: 'Application',
            },
            VISITED: {
                ID: '605bd712bed49524ae40f887',
                NAME: 'Visited',
            },
            REJECTED_APPLICATION: {
                ID: '606e2367c00bcb15b5e70825',
                NAME: 'Rejected Application',
            },
            FRONTDESK: {
                ID: '60ba8dd614ec771249357add',
                NAME: 'Frontdesk',
            },
        },
    },
    CLOSURE_INFORMATION: {
        ID: '5d7a514b5dac12c7449ce043',
        NAME: 'Closure Information',
        LEVEL: 4,
        SUBSTATUSES: {
            SOLD: {
                ID: '605d10cf448ecc1d69de49aa',
                NAME: 'Sold',
            },
        },
    },
    REJECTED: {
        ID: '6913b462b256653e3614b44f',
        NAME: 'Rejected',
        LEVEL: 5,
        SUBSTATUSES: {
            HIGH_PRICING: {
                ID: '6913b4e5b256653e3614b497',
                NAME: 'High Pricing',
            },
            DESIRED_MODEL_UNAVAILABLE: {
                ID: '6913b4f9b256653e3614b4a0',
                NAME: 'Desired Model Unavailable',
            },
            SERVICE_EXPERIENCE_ISSUE: {
                ID: '6913b509b256653e3614b4a9',
                NAME: 'Service Experience Issue',
            },
            FINANCING_CONSTRAINTS: {
                ID: '6913b51bb256653e3614b4b2',
                NAME: 'Financing Constraints',
            },
            ADVERSE_CREDIT_HISTORY: {
                ID: '6913b52db256653e3614b4bb',
                NAME: 'Adverse Credit History',
            },
            CREDIT_OFFER_DECLINED: {
                ID: '6913b53eb256653e3614b4c4',
                NAME: 'Credit Offer Declined',
            },
            NOT_CONTACTED: {
                ID: '6913b54cb256653e3614b4cd',
                NAME: 'Not Contacted',
            },
            ALREADY_PURCHASED: {
                ID: '6913b55fb256653e3614b4d6',
                NAME: 'Already Purchased',
            },
            CREDIT_APPLICATION_REJECTED: {
                ID: '6913b573b256653e3614b4df',
                NAME: 'Credit Application Rejected',
            },
            MODEL_DID_NOT_MEET_REQUIREMENTS: {
                ID: '6913b58ab256653e3614b4e8',
                NAME: 'Model Did Not Meet Requirements',
            },
            MODEL_NOT_AVAILABLE_IN_INVENTORY: {
                ID: '6913b59db256653e3614b4f1',
                NAME: 'Model Not Available in Inventory',
            },
            NOT_INTERESTED: {
                ID: '699345a8ec51bf26261a2316',
                NAME: 'Not Interested',
            },
            WRONG_DATA: {
                ID: '69fa1936e0801600194032e8',
                NAME: 'Wrong Data',
            },
        },
    },
};
